import type * as React from "react";

import classNames from "classnames";

import { useStyles } from "./styles";

type TBaseProps = {
  color?: string;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  rounded?: boolean;
  width?: number;
};

type TProps = TBaseProps & ({ horizontal: true } | { vertical: true });

export const Divider: FC<TProps> = (props) => {
  const {
    className,
    color = "var(--border)",
    onMouseEnter,
    onMouseLeave,
    ref,
    rounded = false,
    width = 1,
  } = props;
  const isHorizontal = "horizontal" in props;
  const classes = useStyles({ width });

  const viewBox = isHorizontal ? "0 0 100 1" : "0 0 1 100";
  const pathD = isHorizontal ? "M0 0.5 L100 0.5" : "M0.5 0 L0.5 100";

  return (
    <div
      className={classNames(classes.divider, { [classes.horizontal]: isHorizontal }, className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
    >
      <svg
        className={classNames(classes.svg, { [classes.horizontal]: isHorizontal, [classes.rounded]: rounded })}
        preserveAspectRatio="none"
        viewBox={viewBox}
      >
        <path d={pathD} fill="none" stroke={color} />
      </svg>
    </div>
  );
};
